(function(){
    function Scroll(){
        this.wowAnimateScrollInit= function() {
            new WOW().init();
        }

        this.scrollToBottomInit = function(){
            var $scrollDownButton = $('.arrowScrollDown');
            var $mainWrapper = $('.main__flexWrapper');
            var $topMenu = $('.topMenu');
            var $topMenuFixed = $('.topMenuFixed');
            
            $scrollDownButton.on('click', function(event){
                var scrollHeight = parseInt($mainWrapper.css('height'));
                var topMenuHeight = $topMenu.height();
                    $('html, body').animate({ scrollTop: scrollHeight-topMenuHeight }, 1000);
            });
        }
    }
    proj.scroll = new Scroll();
})();
